import React from 'react';

const SvgCl = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="CL_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="CL_svg__b" fill="#fff">
        <use xlinkHref="#CL_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path fill="#EA3B2E" mask="url(#CL_svg__b)" d="M0 9.333h28V20H0z" />
      <path fill="#0B48C2" mask="url(#CL_svg__b)" d="M0 0h9.333v9.333H0z" />
      <path
        fill="#FFF"
        mask="url(#CL_svg__b)"
        d="M4.667 5.707L3.099 6.824l.579-1.836L2.13 3.843l1.924-.018L4.667 2l.611 1.825 1.925.018-1.547 1.145.578 1.836z"
      />
    </g>
  </svg>
);

export default SvgCl;
